module.exports = "<div class=\"virtualized-scroll-list\">\n  <div class=\"virtual-list\">\n    <div class=\"virtualized-row\" ng-repeat=\"item in getItemsToRender() track by (offset + $index)\"></div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/directives/virtualized-scroll-list/virtualized-scroll-list.html
// module id = 484
// module chunks = 22